import React from 'react';
import { useUpdateShape } from 'hooks';
import VerticalDivider from 'components/actionBar/components/VerticalDivider';
import Collapse from './Collapse';
import CalendarSizeFields from './CalendarSizeFields';

export const CalendarSizesStyle = ({ shape }) => {
  const onChange = useUpdateShape(shape.id);

  return (
    <Collapse text="Size">
      <CalendarSizeFields
        shape={shape}
        onChange={onChange}
        fieldClassName="number-input"
        separator={<VerticalDivider />}
        inline
      />
    </Collapse>
  );
};

export default CalendarSizesStyle;
